import { extractCountryCode } from "./utils";

export const setPoc = (el = {}) => {
  const { number, countryCode } = extractCountryCode(el.phone_number);
  const title = el.title === 'principle'?'principal':el.title;
  const type = el.type === 'principle'?'principal':el.type;
  return {
    first_name: el.first_name || null,
    last_name: el.last_name || null,
    email: el.email || null,
    prefix: el.prefix || "mr",
    phone_number: number,
    countryCode: countryCode,
    role: title || null,
    type: type || title || null,
    custom_role: el.custom_role || null,
  };
};
